var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "",
        centered: true,
        footer: null,
        maskClosable: false,
        dialogClass: "global-campaign-post-success-modal-class",
        closable: false,
      },
      model: {
        value: _vm.showPostSuccessModal,
        callback: function ($$v) {
          _vm.showPostSuccessModal = $$v
        },
        expression: "showPostSuccessModal",
      },
    },
    [
      _c(
        "div",
        { staticClass: "post-success-con", class: [_vm.lang] },
        [
          _c("svg-icon", {
            staticClass: "post-success-icon",
            attrs: { iconClass: "right" },
          }),
          _c("div", { staticClass: "post-success-title" }, [
            _vm._v(_vm._s(_vm.$t("successModalTitle"))),
          ]),
          _c("div", { staticClass: "post-success-txt" }, [
            _vm._v(_vm._s(_vm.$t("successModalTxt"))),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }